import { gql } from '@apollo/client';

const TRIP_FIELDS = `
  id
  ownerUserId
  accessLevel
  sharedByName
  title
  destination
  startDate
  endDate
  status
  tripType
  countries
  cities
  tags
  coverUrl
  coverPhotoUrl
  coverPhotoUpdatedAt
  favorite
  notes
  updatedAt
  itinerary {
    id
    date
    title
    notes
    items {
      id
      type
      title
      startTime
      endTime
      location
      confirmationNumber
      cost
      link
      notes
    }
  }
  places {
    id
    name
    category
    priority
    address
    assignedDate
    notes
  }
  expenses {
    id
    title
    category
    amount
    currency
    paidDate
    notes
  }
  packingItems {
    id
    title
    category
    packed
  }
  linkedHikes {
    id
    title
    location
    hikeDate
    status
    distance
    distanceUnit
    durationMinutes
    difficulty
    trailType
    terrain
    favorite
    tags
    tripTitle
    tripDayId
    tripDayTitle
  }
`;

const TRIP_LIST_FIELDS = `
  id
  ownerUserId
  accessLevel
  sharedByName
  title
  destination
  startDate
  endDate
  status
  tripType
  tags
  coverUrl
  coverPhotoUrl
  coverPhotoUpdatedAt
  favorite
  updatedAt
  itinerary {
    id
    date
    title
    notes
  }
`;

export const GET_TRIPS = gql`
  query GetTrips($first: Int, $after: String) {
    getTripsListPage(first: $first, after: $after) {
      nodes {
        ${TRIP_LIST_FIELDS}
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_TRIP = gql`
  query GetTrip($id: ID!) {
    getTrip(id: $id) {
      ${TRIP_FIELDS}
    }
  }
`;

export const SEARCH_DESTINATIONS = gql`
  query SearchDestinations($query: String!) {
    searchDestinations(query: $query) {
      id
      label
      destination
      city
      country
      coverUrl
    }
  }
`;

export const GET_TRIP_SHARES = gql`
  query GetTripShares($tripId: ID!) {
    getTripShares(tripId: $tripId) {
      id
      itemId
      granteeUserId
      granteeDisplayName
      granteeEmail
      permission
      status
      createdAt
    }
  }
`;

export const SHARE_TRIP = gql`
  mutation ShareTrip($input: ShareTripInput!) {
    shareTrip(input: $input) {
      id
      itemId
      granteeUserId
      granteeDisplayName
      granteeEmail
      permission
      status
      createdAt
    }
  }
`;

export const REVOKE_TRIP_SHARE = gql`
  mutation RevokeTripShare($id: ID!) {
    revokeTripShare(id: $id)
  }
`;

export const ADD_TRIP = gql`
  mutation AddTrip($input: TripInput!) {
    addTrip(input: $input) {
      ${TRIP_FIELDS}
    }
  }
`;

export const UPDATE_TRIP = gql`
  mutation UpdateTrip($id: ID!, $input: TripInput!) {
    updateTrip(id: $id, input: $input) {
      ${TRIP_FIELDS}
    }
  }
`;

export const DELETE_TRIP = gql`
  mutation DeleteTrip($id: ID!) {
    deleteTrip(id: $id)
  }
`;
